import Icon from '../../components/icons.jsx'

/** Confirmação visual sobre toda a janela, após salvar a conclusão. */
export default function TaskCompletionOverlay({ icon = 'page', onEnd }) {
  return <div className="pj-task-completion-overlay" role="status" onAnimationEnd={event => {
    if (event.target === event.currentTarget) onEnd?.()
  }}>
    <span className="pj-task-completion-sweep" aria-hidden="true"/>
    <div className="pj-task-completion-center">
      <div className="pj-task-completion-symbol" aria-hidden="true">
        <span className="pj-task-completion-ring"/>
        <span className="pj-task-completion-before"><Icon n={icon} s={54}/></span>
        <svg className="pj-task-completion-check" viewBox="0 0 64 64" fill="none"><path d="m15 32 11 11 24-25" pathLength="1" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </div>
      <strong>Tarefa concluída</strong>
    </div>
  </div>
}
